export const CHANGE_COLLAPSE = 'CHANGE_COLLAPSE'